import * as React from "react"
import { styled } from "@mui/material/styles"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"

import { useAppDispatch } from "../../../redux/hooks"
import { AlertModal } from "./Atom"

interface StyledTabsProps {
  children?: React.ReactNode
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
}
interface StyledTabProps {
  label: string
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    height: "4px",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "34px",
    backgroundColor: "#3C77EF",
  },
})

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(16),
  marginLeft: theme.typography.pxToRem(46),
  paddingLeft: 0,
  color: "#707070",
  "&.Mui-selected": {
    color: "#000",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#3C77EF",
  },
}))

interface tabProps {
  additionalOptions?: React.ReactNode[]
  tabValues: string[]
  index: number
  tabContainerStyles?: React.CSSProperties
  optionsContainerStyles?: React.CSSProperties
  dispatchFun: (index: number) => any
  dirty: boolean
}

const ResourceBudgetTabs = ({
  tabValues,
  additionalOptions,
  index,
  tabContainerStyles,
  optionsContainerStyles,
  dirty,
  dispatchFun,
}: tabProps) => {
  const dispatch = useAppDispatch()
  const [alertState, setAlertState] = React.useState({
    open: false,
    tabValue: -1,
  })
  const handleChange = (_: any, newValue: number) => {
    if (!dirty) {
      dispatch(dispatchFun(newValue))
    } else {
      setAlertState({ tabValue: newValue, open: true })
    }
  }

  const confirmActionHandler = () => {
    dispatch(dispatchFun(alertState.tabValue))
    setAlertState((prev) => ({ ...prev, open: false }))
  }
  const alertCloseHandler = () =>
    setAlertState((prev) => ({ ...prev, open: false }))

  if (!tabValues) {
    return true
  }

  return (
    <Box
      sx={{
        display: "flex",
        borderBottom: "1px solid #EFF0F5",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: "5px",
        ...tabContainerStyles,
      }}
    >
      <StyledTabs
        value={index}
        onChange={handleChange}
        aria-label="budget-tabs"
      >
        {tabValues.map((tab: any, index: any) => {
          return <StyledTab label={tab} key={`tab-${index}`} />
        })}
      </StyledTabs>

      <Box
        sx={{
          display: "flex",
          gap: "9px",
          alignItems: "center",
          marginRight: "11px",
          ...optionsContainerStyles,
        }}
      >
        {additionalOptions}
      </Box>
      <AlertModal
        close={alertCloseHandler}
        open={alertState.open}
        title={"Tab switch alert"}
        optionalMessage="You've unsaved work in this tab. Switching tab can cause you loose that work."
        buttonText={"Switch anyway"}
        confirmActionHandler={confirmActionHandler}
      />
    </Box>
  )
}

export default ResourceBudgetTabs
